import { render, staticRenderFns } from "./adddelegateteamdialog.vue?vue&type=template&id=2b507f26&scoped=true&"
import script from "./adddelegateteamdialog.vue?vue&type=script&lang=js&"
export * from "./adddelegateteamdialog.vue?vue&type=script&lang=js&"
import style0 from "./adddelegateteamdialog.vue?vue&type=style&index=0&id=2b507f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b507f26",
  null
  
)

export default component.exports